import { render, staticRenderFns } from "./ModalBuscarProducto.vue?vue&type=template&id=08353770&scoped=true&"
import script from "./ModalBuscarProducto.vue?vue&type=script&lang=js&"
export * from "./ModalBuscarProducto.vue?vue&type=script&lang=js&"
import style0 from "./ModalBuscarProducto.vue?vue&type=style&index=0&id=08353770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08353770",
  null
  
)

export default component.exports